var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { queryAssignedElements, property } from 'lit/decorators.js';
import { isEmpty } from 'lodash-es';
import { fastDom } from '../utilities/dom';
let ExpandableContainerLit = (() => {
    var _a, _ExpandableContainerLit__contentSlot_accessor_storage, _ExpandableContainerLit__textSlot_accessor_storage, _ExpandableContainerLit_heading_accessor_storage;
    let _classSuper = LitElement;
    let __contentSlot_decorators;
    let __contentSlot_initializers = [];
    let __contentSlot_extraInitializers = [];
    let __textSlot_decorators;
    let __textSlot_initializers = [];
    let __textSlot_extraInitializers = [];
    let _heading_decorators;
    let _heading_initializers = [];
    let _heading_extraInitializers = [];
    return _a = class ExpandableContainerLit extends _classSuper {
            constructor() {
                super(...arguments);
                _ExpandableContainerLit__contentSlot_accessor_storage.set(this, __runInitializers(this, __contentSlot_initializers, void 0));
                _ExpandableContainerLit__textSlot_accessor_storage.set(this, (__runInitializers(this, __contentSlot_extraInitializers), __runInitializers(this, __textSlot_initializers, void 0)));
                _ExpandableContainerLit_heading_accessor_storage.set(this, (__runInitializers(this, __textSlot_extraInitializers), __runInitializers(this, _heading_initializers, void 0)));
                this._isContent = __runInitializers(this, _heading_extraInitializers);
            }
            get _contentSlot() { return __classPrivateFieldGet(this, _ExpandableContainerLit__contentSlot_accessor_storage, "f"); }
            set _contentSlot(value) { __classPrivateFieldSet(this, _ExpandableContainerLit__contentSlot_accessor_storage, value, "f"); }
            get _textSlot() { return __classPrivateFieldGet(this, _ExpandableContainerLit__textSlot_accessor_storage, "f"); }
            set _textSlot(value) { __classPrivateFieldSet(this, _ExpandableContainerLit__textSlot_accessor_storage, value, "f"); }
            /**
             * The main heading or title displayed in this popover.
             * This provides a quick summary or title of the popover's content.
             *
             * @attr {string} heading - Title of the popover.
             */
            get heading() { return __classPrivateFieldGet(this, _ExpandableContainerLit_heading_accessor_storage, "f"); }
            set heading(value) { __classPrivateFieldSet(this, _ExpandableContainerLit_heading_accessor_storage, value, "f"); }
            get isContent() {
                return this._isContent;
            }
            getContentSlot() {
                if (!isEmpty(this._contentSlot)) {
                    this._isContent = true;
                    return this._contentSlot;
                }
                else {
                    return this._textSlot;
                }
            }
            async calculateBodyOverflows(content, container) {
                return fastDom.measure(() => content.scrollHeight > container.clientHeight);
            }
            toggleBodySize() {
                this.isExpanded ? this.collapseContainer() : this.expandContainer();
            }
            collapse(container, styleName) {
                this.isExpanded = false;
                this.removeLargeHeightStyle(container, styleName);
            }
            expand(container, styleName) {
                this.isExpanded = true;
                this.addLargeHeightStyle(container, styleName);
            }
            addLargeHeightStyle(container, styleName) {
                container.classList.add(styleName);
            }
            removeLargeHeightStyle(container, styleName) {
                container.classList.remove(styleName);
            }
        },
        _ExpandableContainerLit__contentSlot_accessor_storage = new WeakMap(),
        _ExpandableContainerLit__textSlot_accessor_storage = new WeakMap(),
        _ExpandableContainerLit_heading_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            __contentSlot_decorators = [queryAssignedElements({ slot: 'content' })];
            __textSlot_decorators = [queryAssignedElements({ slot: 'text' })];
            _heading_decorators = [property({ type: String })];
            __esDecorate(_a, null, __contentSlot_decorators, { kind: "accessor", name: "_contentSlot", static: false, private: false, access: { has: obj => "_contentSlot" in obj, get: obj => obj._contentSlot, set: (obj, value) => { obj._contentSlot = value; } }, metadata: _metadata }, __contentSlot_initializers, __contentSlot_extraInitializers);
            __esDecorate(_a, null, __textSlot_decorators, { kind: "accessor", name: "_textSlot", static: false, private: false, access: { has: obj => "_textSlot" in obj, get: obj => obj._textSlot, set: (obj, value) => { obj._textSlot = value; } }, metadata: _metadata }, __textSlot_initializers, __textSlot_extraInitializers);
            __esDecorate(_a, null, _heading_decorators, { kind: "accessor", name: "heading", static: false, private: false, access: { has: obj => "heading" in obj, get: obj => obj.heading, set: (obj, value) => { obj.heading = value; } }, metadata: _metadata }, _heading_initializers, _heading_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { ExpandableContainerLit };
